import { css } from 'aphrodite';
import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { MastheadPortalId } from '../../../models/AdminModels';
import { IUserSessionComponentProps, UserSessionViewModelKey } from '../../../models/AppState';
import { PortalDestination } from '../../../web/components/Portal';
import { UserProfileNav } from '../../../web/components/UserProfileNav';
import { styleSheet } from './styles';

interface IProps extends RouteComponentProps<any>, IUserSessionComponentProps {
	className?: string;
}

class _Masthead extends React.Component<IProps> {
	public render() {
		const { className, ...restProps } = this.props;
		return (
			<div className={`masthead ${css(styleSheet.container)} ${className || ''}`}>
				<div className={`masthead-content ${css(styleSheet.content)}`}>
					<div className={`masthead-navigation-item ${css(styleSheet.navItem)}`}>
						<PortalDestination id={MastheadPortalId} />
					</div>
					<UserProfileNav isAdminPage={true} {...restProps} />
				</div>
			</div>
		);
	}
}

const MastheadWithRouter = withRouter(_Masthead);
export const Masthead = inject(UserSessionViewModelKey)(MastheadWithRouter);
